import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SharedLayout from "./Components/SharedLayout";
import Error from "./Components/Error";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import AuthPage from "./Pages/SignupPage";
import "../src/input.css";
import Sidebar from "./UserDashboard/SideBar";
import { useAuthStore } from "./store/store";
import TransactionsTab from "./UserDashboard/TransactionsTab";
import RewardsTab from "./UserDashboard/RewardsTab";
import InvestmentsTab from "./UserDashboard/InvestmentsTab";
import InvestmentPlanEditor from "./Admin-Userdashboard/InvestmentPlanEditor";
import CashoutTab from "./UserDashboard/CashoutTab";
import SettingsTab from "./UserDashboard/SettingsTab";
import DepositTab from "./UserDashboard/DepositTab";
import ReferralTab from "./UserDashboard/ReferralTab";
import SignupPage from "./Pages/SignupPage";
import LoginPage from "./Pages/LoginPage";
import CreateInvestmentPlan from "./Admin-Userdashboard/CreateInvestmentPlan";
import User from "./UserDashboard/User";
import Crypto from "./UserDashboard/Crypto";
import PrivacyPolicy from "./Pages/PrivacyPolicy";

const App = () => {
  const { authPrivateDataUrl } = useAuthStore();
  useEffect(() => {
    authPrivateDataUrl();
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<SharedLayout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={ <PrivacyPolicy /> } />
          <Route path="/create-account" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/dashboard" element={<Sidebar />}>
            <Route index element={<InvestmentsTab />} />
            <Route path="investments" element={<InvestmentsTab />} />
            <Route
              path="CreateInvestmentPlan"
              element={<CreateInvestmentPlan />}
            />
            <Route
              path="createInvestmentEdit/:id"
              element={<InvestmentPlanEditor />}
            />
            <Route path="user" element={<User />} />
            <Route path="chart" element={<Crypto />} />
            <Route path="rewards" element={<RewardsTab />} />
            <Route path="investments" element={<InvestmentsTab />} />
            <Route path="deposit" element={<DepositTab />} />
            <Route path="referral" element={<ReferralTab />} />
            <Route path="cashout" element={<CashoutTab />} />
            <Route path="settings" element={<SettingsTab />} />
          </Route>
        </Route>
        <Route path="*" element={<Error />} />
      </Routes>
    </Router>
  );
};

export default App;
